module.exports = __webpack_public_path__ + "static/media/HH03232024.3f164a18.pdf";